/* FIG Couture — behaviour for every page. Markup comes from Liquid; this file
   wires it: menus, search, bag, wishlist, recommendation rails, filters and
   Load more, the product page and the brands page. Product cards and rails
   are fetched through Shopify's Section Rendering API (?section_id=…). */
(function () {
  'use strict';
  var F = window.FIG || {};
  var R = F.routes || {};
  /* The language root: "" in English, "/ar" in Arabic. Every path the script fetches starts with it, so cards fetched on the Arabic site come back in Arabic. */
  var ROOT = (R.root || '/').replace(/\/$/, '');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var html = document.documentElement;
  /* Arabic runs right to left, where a scroller's scrollLeft counts down from 0: every horizontal scroll is multiplied by this. */
  var DIR = html.getAttribute('dir') === 'rtl' ? -1 : 1;
  /* Every word the script writes, from the theme's locale files (window.FIG.t in theme.liquid), so
     the Arabic site does not fall back to English the moment something is added to the bag. */
  var T = F.t || {};
  var tr = function (k, vars) { var s = T[k] || k; if (vars) Object.keys(vars).forEach(function (n) { s = s.split('{' + n + '}').join(vars[n]); }); return s; };
  var store = function (k, v) {
    try {
      if (arguments.length === 1) return JSON.parse(localStorage.getItem(k));
      localStorage.setItem(k, JSON.stringify(v));
    } catch (e) { return null; }
  };
  function lock(on) { html.classList.toggle('lock', on); }
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2200);
  }
  function money(cents) {
    var f = F.moneyFormat || 'LE {{amount}}';
    var n = (cents / 100);
    /* Two decimals always: Labesny's own format is "{{amount}}0 KD", which writes the third. */
    var two = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var none = Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, none).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, two.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, two).replace(/<[^>]+>/g, '');
  }
  function sectionUrl(url, id) { return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + id; }
  function fetchSection(url, id) {
    return fetch(sectionUrl(url, id), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) {
      var d = document.createElement('div');
      d.innerHTML = t;
      return d;
    });
  }
  /* Colour name → dot. Checked in order, so the specific shades come before the plain families
     ("baby pink" before "pink", "navy" before "blue"), and every English word is matched whole
     (W): "pink" once matched "ink" and showed navy. Arabic names are matched as written. */
  function W(words) { return new RegExp('(?:^|[^a-z])(?:' + words + ')(?![a-z])'); }
  var GOLD_SILVER = 'linear-gradient(135deg,#d8b45a 50%,#c9ccd1 50%)';
  var SW = [
    [/أسود/, '#151515'], [/أبيض/, '#ffffff'], [/سكري|عاجي|كريمي/, '#f1e8d6'], [/بيج|نود/, '#d9c2a3'], [/كحلي/, '#1f2a44'], [/سماوي|أزرق فاتح/, '#9cc3e6'], [/أزرق/, '#3f6fb5'],
    [/نبيتي|عنابي/, '#6b1f2e'], [/أحمر/, '#b7282e'], [/وردي|زهري/, '#efb1c0'], [/زيتي/, '#6b6b3a'], [/أخضر/, '#4f7d55'], [/رمادي/, '#9b9b98'], [/بني/, '#6f4a33'],
    [/ذهبي|فضي/, GOLD_SILVER], [/أصفر/, '#f0d24a'], [/برتقالي/, '#e8803a'], [/بنفسجي|موف|ليلكي/, '#8e6bb0'],
    [/gold.*silver|silver.*gold/, GOLD_SILVER], [W('gold|mustard|ochre'), '#c9a23a'], [W('silver'), '#c9ccd1'],
    [W('burgundy|bordeaux|wine|maroon|oxblood'), '#6b1f2e'],
    [W('off ?white|ivory|cream|ecru|vanilla|bone|kashmir'), '#f1e8d6'], [W('black|noir|negro|jet'), '#151515'], [W('white|blanc|optical|snow'), '#ffffff'],
    [W('camel|tan|cognac|caramel'), '#b98a5a'], [W('beige|sand|nude|skin|stone|sable|latte|taupe'), '#d9c2a3'],
    [W('navy|marine|midnight'), '#1f2a44'], [W('light denim|bleach'), '#8fb0cf'], [W('denim|indigo|dark blue|blue dark'), '#2f4a6e'],
    [W('baby blue|light blue|sky|powder blue|ciel|aqua|ice'), '#9cc3e6'], [W('slate|slate blue'), '#6c7f99'], [W('turquoise|teal'), '#2a9d9a'], [W('blue|bleu|azul|cobalt|royal'), '#3f6fb5'],
    [W('baby pink|light pink|blush|powder|pale pink'), '#f6cfd8'], [W('fuchsia|magenta|hot pink'), '#d63384'], [W('coral|salmon|simon|peach|corail|apricot'), '#f2a18a'],
    [W('deep rose|dusty rose|old rose'), '#c27b8a'], [W('pink|rose|rosa'), '#efb1c0'],
    [W('red|rouge|cherry|scarlet'), '#b7282e'],
    [W('mint|sage|pistachio'), '#a9cdb0'], [W('olive|kaki|khaki|army'), '#6b6b3a'], [W('green|vert|emerald|bottle|lime'), '#4f7d55'],
    [W('dark grey|dark gray|charcoal|anthracite'), '#4d4d4f'], [W('light grey|light gray|melange|chine|heather'), '#c6c6c3'], [W('grey|gray|gris'), '#9b9b98'],
    [W('brown|marron|brun|chocolate|coffee|mocha|rust'), '#6f4a33'],
    [W('yellow|jaune|lemon'), '#f0d24a'], [W('orange'), '#e8803a'], [W('lilac|lavender|lila'), '#c3b1dd'], [W('purple|violet|plum|mauve'), '#8e6bb0']];
  function plain(n) {
    for (var i = 0; i < SW.length; i++) if (SW[i][0].test(n)) return SW[i][1];
    return '';
  }
  /* Prints get a pattern rather than a rainbow: leopard spots on camel; stripes and checks in the
     colour they are named with ("Blue Plaid"); a named floral or print ("Blue Floral") the plain
     colour; only "multi" with no colour gets the soft four-colour wheel. */
  function swatch(name) {
    var n = String(name || '').toLowerCase();
    var c = plain(n), ink = c.charAt(0) === '#' && c !== '#ffffff' ? c : '#1f2a44';
    if (/leopard|animal|cheetah|نمر/.test(n)) return 'radial-gradient(circle at 30% 30%,#3b2a1e 0 12%,transparent 13%),radial-gradient(circle at 70% 62%,#3b2a1e 0 12%,transparent 13%),radial-gradient(circle at 32% 78%,#3b2a1e 0 9%,transparent 10%),#c99a62';
    if (/stripe|rayé|مقلم/.test(n)) return 'repeating-linear-gradient(90deg,' + ink + ' 0 3px,#fff 3px 6px)';
    if (/check|plaid|tartan|carreaux|كاروه/.test(n)) return 'repeating-linear-gradient(0deg,' + ink + '99 0 3px,transparent 3px 6px),repeating-linear-gradient(90deg,' + ink + '99 0 3px,#fff 3px 6px)';
    if (c) return c;
    if (/print|multi|flower|floral|pattern|منقوش|ملوّن|ملون|مورد/.test(n)) return 'conic-gradient(#efb1c0 0 25%,#9cc3e6 0 50%,#f0d24a 0 75%,#a9cdb0 0)';
    return '#cfcac2';
  }
  /* Sizes arrive in the order the catalogue stored them; show them small to large. */
  var LETTER = ['XXXS', '3XS', 'XXS', '2XS', 'XS', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL'];
  function sizeRank(s) {
    var t = String(s).trim().toUpperCase();
    var i = LETTER.indexOf(t);
    if (i >= 0) return i;
    var n = parseFloat(t.replace(',', '.'));
    if (!isNaN(n)) return 100 + n;
    return 10000;
  }
  function sortSizes(root) {
    $$('.qa-sizes, [data-pick], .sheet .chips, .fd .fsizes', root).forEach(function (box) {
      var kids = $$(':scope > button, :scope > label', box);
      if (kids.length < 2) return;
      var label = function (b) { return b.dataset.val || b.textContent; };
      kids.slice().sort(function (a, b) { var d = sizeRank(label(a)) - sizeRank(label(b)); return d || 0; }).forEach(function (b) { box.appendChild(b); });
    });
  }
  /* Etam writes some bra sizes "85 Cup D" and others "85D": one way of writing them everywhere they show. */
  function tidySizes(root) {
    $$('.qa-sizes button, .sheet .chips button, .fd .chip-t, .sizes button', root).forEach(function (b) {
      if (b.children.length) return;
      var t = b.textContent, n = t.replace(/^\s*(\d{2,3})\s*cup\s*([a-h]{1,3})\s*$/i, '$1$2');
      if (n !== t) b.textContent = n.toUpperCase();
    });
  }
  function paintSwatches(root) {
    tidySizes(root); sortSizes(root); $$('[data-swatch]', root).forEach(function (el) { if (!el.style.background) el.style.background = swatch(el.dataset.swatch); }); }

  /* ── wishlist ─────────────────────────────────────── */
  var wish = store('fig-wish') || [];

  /* A signed-in shopper's saves also live in the Labesny app's backend (Medusa), so the list is the
     same on every device and in the app, and the team can see what people save. window.FIG.sync is
     only there for a signed-in customer, with a signature Shopify made for them (theme.liquid).
     A guest's list stays on this device, as before.

     On load the two lists are joined. "fig-wish-synced" remembers what the backend already had, so
     a piece taken off on another device leaves here too instead of being sent back. */
  var SYNC = window.FIG && FIG.sync;
  function pushWish(add, remove) {
    if (!SYNC || (!add.length && !remove.length)) return;
    try {
      fetch(SYNC.url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ cid: SYNC.cid, email: SYNC.email, sig: SYNC.sig, add: add, remove: remove }) })
        .then(function (r) { if (r.ok) store('fig-wish-synced', wish); }).catch(function () {});
    } catch (e) {}
  }
  var wishReady = !SYNC ? Promise.resolve() : fetch(SYNC.url + '?' + new URLSearchParams({ cid: SYNC.cid, email: SYNC.email, sig: SYNC.sig }))
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || !Array.isArray(d.handles)) return;
      var server = d.handles, synced = store('fig-wish-synced') || [];
      var fresh = wish.filter(function (h) { return server.indexOf(h) < 0 && synced.indexOf(h) < 0; });
      var next = wish.filter(function (h) { return server.indexOf(h) >= 0 || fresh.indexOf(h) >= 0; })
        .concat(server.filter(function (h) { return wish.indexOf(h) < 0; }));
      wish.length = 0; Array.prototype.push.apply(wish, next);
      store('fig-wish', wish); store('fig-wish-synced', server);
      paintWish(document);
      pushWish(fresh, []);
    })
    .catch(function () {});

  function paintWish(root) {
    $$('[data-wish]', root).forEach(function (b) { var on = wish.indexOf(b.dataset.wish) >= 0; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-c-wish]').forEach(function (el) { el.textContent = wish.length; el.hidden = !wish.length; });
  }
  function toggleWish(h) {
    var i = wish.indexOf(h);
    if (i >= 0) wish.splice(i, 1); else wish.unshift(h);
    store('fig-wish', wish);
    paintWish(document);
    pushWish(i < 0 ? [h] : [], i >= 0 ? [h] : []);
    /* On the wishlist itself (the page or the profile's tab), a piece taken off leaves at once, and
       the empty note shows when the last one goes. */
    if (i >= 0) $$('[data-wgrid] .card, [data-acct-wish] .card').forEach(function (c) {
      if (c.dataset.handle !== h) return;
      var grid = c.parentNode;
      c.remove();
      if (!grid.children.length) $$('[data-wempty], [data-acct-wempty]').forEach(function (e) { e.hidden = false; });
    });
    toast(i < 0 ? tr('wish_saved') : tr('wish_removed'));
  }

  /* ── bag ──────────────────────────────────────────── */
  var bagEl = $('#bag');
  function setBag(sectionsHtml) {
    if (!sectionsHtml) return;
    var d = document.createElement('div');
    d.innerHTML = sectionsHtml;
    var inner = $('.shopify-section', d) || d;
    var panel = $('#bag-panel');
    panel.innerHTML = '';
    panel.appendChild(inner);
    var count = $$('.bag-line', panel).reduce(function (n, l) { return n + Number(($('.qty span', l) || {}).textContent || 0); }, 0);
    $$('[data-c-bag]').forEach(function (el) { el.textContent = count; el.hidden = !count; });
    fillBagRecs();
  }
  function openBag() {
    bagEl.hidden = false;
    lock(true);
    fillBagRecs();
  }
  function closeBag() { bagEl.hidden = true; lock(false); }
  /* The cart page is re-drawn in place, never reloaded (Labesny, 10 October): its own section comes
     back with the bag's in the same response, through the Section Rendering API, and replaces the
     old one — lines, totals, the gift-tier line and the "complete the set" rail. */
  function cartSectionId() {
    var el = $('.cart-page');
    var sec = el && el.closest('.shopify-section');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }
  function sectionsParam() { var id = cartSectionId(); return id ? 'fig-bag,' + id : 'fig-bag'; }
  function setCartPage(sections) {
    var id = cartSectionId();
    if (!id || !sections || !sections[id]) return;
    var holder = document.getElementById('shopify-section-' + id);
    var d = document.createElement('div');
    d.innerHTML = sections[id];
    var fresh = $('.shopify-section', d) || d;
    holder.innerHTML = fresh.innerHTML;
    paintWish(holder);
    paintSwatches(holder);
    $$('[data-rail]', holder).forEach(function (r) { if (r.dataset.fill) fillRail(r); else wireRail(r); });
  }
  var busyLine = false;
  function addToBag(items) {
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: sectionsParam(), sections_url: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || tr('add_failed')); return j; }); })
      .then(function (j) {
        setBag(j.sections && j.sections['fig-bag']);
        smartPromo(true);
        if (document.body.classList.contains('t-cart')) { setCartPage(j.sections); toast(tr('added')); } else openBag();
      })
      .catch(function (e) { toast(e.message); });
  }
  function changeLine(line, qty) {
    if (busyLine) return Promise.resolve();
    busyLine = true;
    var row = $$('[data-line="' + line + '"]')[0];
    var lineEl = row && row.closest('.bag-line');
    if (lineEl) lineEl.classList.add('busy');
    return fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: sectionsParam(), sections_url: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        setBag(j.sections && j.sections['fig-bag']);
        if (document.body.classList.contains('t-cart')) setCartPage(j.sections);
      })
      .catch(function () { toast(tr('add_failed')); })
      .then(function () { busyLine = false; if (lineEl) lineEl.classList.remove('busy'); });
  }
  /* Share the bag by email (snippets/fig-bag-actions): the envelope opens a field for the friend's
     address, and Send opens the mail app already addressed to them, with the bag's link in the body.
     Delegated, because the bag is redrawn after every change. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mail-toggle]');
    if (t) {
      var f = t.closest('.share-bag') && t.closest('.share-bag').parentElement.querySelector('[data-mailform]');
      if (!f) return;
      e.preventDefault();
      f.hidden = !f.hidden;
      t.setAttribute('aria-expanded', String(!f.hidden));
      if (!f.hidden) $('[data-mail-to]', f).focus();
      return;
    }
    var b = e.target.closest && e.target.closest('[data-mail-send]');
    if (b) { e.preventDefault(); sendMail(b.closest('[data-mailform]')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-mail-to]')) { e.preventDefault(); sendMail(e.target.closest('[data-mailform]')); }
  });
  function sendMail(f) {
    var to = $('[data-mail-to]', f);
    var addr = to.value.trim();
    if (!addr || !to.checkValidity()) { to.setAttribute('aria-invalid', 'true'); to.reportValidity && to.reportValidity(); to.focus(); return; }
    to.removeAttribute('aria-invalid');
    window.location.href = 'mailto:' + addr.replace(/[^\w.@+-]/g, '') + '?subject=' + f.dataset.subject + '&body=' + f.dataset.body;
  }

  /* The brand closest to its next store credit level (snippets/fig-promo-nudge puts it on
     .nudge-box): its own full-price pieces, cheapest first, priced at or above the gap — one of
     these in the bag and the level is reached. */
  function gapCards(box, inBag) {
    if (!box || !box.dataset.gap) return Promise.resolve(null);
    var gap = Number(box.dataset.gap);
    /* the storefront price filter asks for pieces at or above the gap, cheapest first */
    return cardsFrom(ROOT + '/collections/' + box.dataset.gapDh + '-' + box.dataset.gapVendor + '?sort_by=price-ascending&filter.v.price.gte=' + (gap / 100).toFixed(2)).then(function (cs) {
      /* full price only: a sale piece doesn't count towards store credit (Moody, 13 Oct) */
      cs = cs.filter(function (c) { return Number(c.dataset.price) >= gap && inBag.indexOf(c.dataset.id) < 0 && !c.hasAttribute('data-sale'); }).slice(0, 8);
      return cs.length ? { cards: cs, title: tr('gap_title', { pct: box.dataset.gapPct, brand: box.dataset.gapBrand }) } : null;
    });
  }
  var recsFor = null;
  function fillBagRecs() {
    var box = $('[data-bag-recs]');
    if (!box) return;
    var bodyEl = $('.bag-body');
    var first = bodyEl && bodyEl.dataset.first;
    var gb = $('#bag-panel .nudge-box');
    var key = (first || 'empty') + ':' + (gb && gb.dataset.gap || '');
    if (recsFor === key && $('.card', box)) { box.hidden = false; return; }
    recsFor = key;
    var inBag = (bodyEl.dataset.ids || '').split(',');
    var left = Number(bodyEl.dataset.left || 0);
    /* What completes the piece just added — its matching set first, then what it is worn with —
       and Shopify's related products behind that. An empty bag shows what is new. */
    var gapBox = $('#bag-panel .nudge-box');
    var h4 = $('h4', box);
    var src = gapCards(gapBox, inBag).then(function (g) {
      if (g) { h4.textContent = g.title; var d0 = document.createElement('div'); g.cards.forEach(function (c) { d0.appendChild(c); }); return d0; }
      h4.textContent = first ? tr('set') : tr('popular');
      return first
        ? Promise.all([setCards(bodyEl.dataset), fetchSection(R.recs + '?product_id=' + first + '&limit=10&intent=related', 'fig-recs').then(function (d) { return $$('.card', d); })]).then(function (l) { var d = document.createElement('div'); l[0].concat(l[1]).forEach(function (c) { d.appendChild(c); }); return d; })
        : fetchSection(ROOT + '/collections/' + deptHandle() + '-new', 'fig-cards');
    });
    src.then(function (d) {
      var seenIds = {};
      var cards = $$('.card', d).filter(function (c) { if (inBag.indexOf(c.dataset.id) >= 0 || seenIds[c.dataset.id]) return false; seenIds[c.dataset.id] = 1; return true; });
      // When free delivery is close, what gets the shopper over the line comes first.
      if (first && left > 0) cards.sort(function (a, b) { var A = Number(a.dataset.price) >= left ? Number(a.dataset.price) : 1e12, B = Number(b.dataset.price) >= left ? Number(b.dataset.price) : 1e12; return A - B; });
      cards = cards.slice(0, 6);
      if (!cards.length) { box.hidden = true; return; }
      var track = $('.track', box);
      track.innerHTML = '';
      cards.forEach(function (c) { $$('.qa, .c-save, .c-sw, .badge-new', c).forEach(function (x) { x.remove(); }); track.appendChild(c); });
      paintWish(box);
      box.hidden = false;
    });
  }
  function deptHandle() { return { men: 'men', kids: 'kids' }[document.body.dataset.dept] || 'women'; }

  /* ── size sheet (phones) ──────────────────────────── */
  function sizeSheet(card, variants, colour) {
    var ci = Number(card.dataset.ci), si = Number(card.dataset.si);
    var list = variants.filter(function (v) { return ci < 0 || v.o[ci] === colour; });
    var el = document.createElement('div');
    el.className = 'sheet';
    var name = ($('.c-name', card) || {}).textContent || '';
    el.innerHTML = '<div class="sheet-scrim" data-x></div><div class="sheet-panel" role="dialog" aria-modal="true" aria-label="' + tr('select_size') + '"><h3>' + tr('select_size') + ' <button type="button" data-x aria-label="' + tr('close') + '">✕</button></h3><p></p><div class="chips"></div></div>';
    $('p', el).textContent = name + (colour ? ' · ' + colour : '');
    $('.chips', el).innerHTML = list.map(function (v) { return '<button type="button" class="chip" data-v="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + (si >= 0 ? v.o[si] : v.o.join(' / ')) + '</button>'; }).join('');
    document.body.appendChild(el);
    sortSizes(el);
    lock(true);
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-v]');
      if (e.target.closest('[data-x]') || b) { el.remove(); lock(false); }
      if (b && !b.disabled) addToBag([{ id: Number(b.dataset.v), quantity: 1 }]);
    });
  }
  function cardVariants(card) { try { return JSON.parse($('[data-variants]', card).textContent); } catch (e) { return []; } }

  /* one listener for cards, hearts, the bag and drawers */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-wish]');
    if (w) { e.preventDefault(); toggleWish(w.dataset.wish); return; }
    if (e.target.closest('#bagbtn')) { e.preventDefault(); openBag(); return; }
    if (e.target.closest('#bag [data-x]')) { closeBag(); return; }
    var ln = e.target.closest('[data-line]');
    if (ln) { changeLine(ln.dataset.line, ln.dataset.qty); return; }
    var card = e.target.closest('.card');
    if (!card) return;
    var qa = e.target.closest('.qa-sizes [data-variant]');
    if (qa && !qa.disabled) { addToBag([{ id: Number(qa.dataset.variant), quantity: 1 }]); return; }
    var sw = e.target.closest('.c-sw [data-colour]');
    if (sw) {
      var vs = cardVariants(card), ci = Number(card.dataset.ci), si = Number(card.dataset.si);
      card.dataset.colour = sw.dataset.colour;
      $$('.c-sw i', card).forEach(function (i) { i.classList.toggle('on', i === sw); });
      var colour = sw.dataset.swatch;
      var box = $('.qa-sizes', card);
      if (box) box.innerHTML = vs.filter(function (v) { return v.o[ci] === colour; }).map(function (v) { return '<button type="button" data-variant="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + (si >= 0 ? v.o[si] : v.o.join(' / ')) + '</button>'; }).join('');
      pickColour(card, sw);
      return;
    }
    if (e.target.closest('.c-add')) {
      var vs2 = cardVariants(card), ci2 = Number(card.dataset.ci);
      var on = $('.c-sw i.on', card);
      var colour2 = on ? on.dataset.swatch : (ci2 >= 0 && vs2[0] ? vs2[0].o[ci2] : '');
      var open = vs2.filter(function (v) { return (ci2 < 0 || v.o[ci2] === colour2) && v.a; });
      if (vs2.length === 1 && open.length) addToBag([{ id: open[0].id, quantity: 1 }]); else sizeSheet(card, vs2, colour2);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeBag(); closeMega(); $$('.fd:not([hidden]), .drawer:not([hidden])').forEach(function (d) { d.hidden = true; }); lock(false); } });

  /* ── the shopper's department ─────────────────────── */
  /* The department sticks until the shopper changes it (Labesny, 10 October). A page that belongs
     to a department (body[data-dept-own]) records it; a page that does not — cart, wishlist, search,
     account — shows the recorded one: its menu, its logo link, its button, its drawer tab. */
  (function () {
    var b = document.body;
    var saved = store('lab-dept');
    var cur = b.hasAttribute('data-dept-own') ? b.dataset.dept : (saved || b.dataset.dept);
    store('lab-dept', cur);
    if (cur === b.dataset.dept) return;
    b.dataset.dept = cur;
    $$('.menu[data-dmenu]').forEach(function (m) { var on = m.dataset.dmenu === cur; m.hidden = !on; if (on) m.id = 'menu'; else m.removeAttribute('id'); });
    $$('[data-go-dept]').forEach(function (a) { if (a.dataset.goDept === cur) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current'); });
    var mark = $('.mark[data-home-' + cur + ']');
    if (mark) mark.setAttribute('href', mark.getAttribute('data-home-' + cur));
    $$('#drawer [data-d]').forEach(function (t) { t.setAttribute('aria-selected', t.dataset.d === cur); });
    $$('#drawer [data-dbody]').forEach(function (x) { x.hidden = x.dataset.dbody !== cur; });
  })();
  /* choosing a department with the top-left buttons is the one thing that changes it */
  document.addEventListener('click', function (e) { var g = e.target.closest('[data-go-dept]'); if (g) store('lab-dept', g.dataset.goDept); });

  /* ── header ───────────────────────────────────────── */
  var openLi = null, megaT;
  function closeMega() { if (openLi) openLi.classList.remove('open'); openLi = null; }
  $$('.menu[data-dmenu] > li, #menu > li').forEach(function (li) {
    if (!$('.mega', li)) return;
    li.addEventListener('mouseenter', function () { clearTimeout(megaT); megaT = setTimeout(function () { closeMega(); li.classList.add('open'); openLi = li; }, 90); });
    li.addEventListener('mouseleave', function () { clearTimeout(megaT); megaT = setTimeout(closeMega, 140); });
    li.addEventListener('focusin', function () { closeMega(); li.classList.add('open'); openLi = li; });
  });
  var hdr = $('#hdr');
  var annBar = $('.bar');
  function setHdr() {
    if (hdr) html.style.setProperty('--hdr', hdr.offsetHeight + 'px');
    html.style.setProperty('--bar', (annBar ? annBar.offsetHeight : 0) + 'px');
  }
  setHdr();
  addEventListener('resize', setHdr);
  var drawer = $('#drawer');
  if (drawer) {
    $('#burger').addEventListener('click', function () { drawer.hidden = false; lock(true); });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-x]')) { drawer.hidden = true; lock(false); return; }
      var t = e.target.closest('[data-d]');
      if (t) { $$('[data-d]', drawer).forEach(function (b) { b.setAttribute('aria-selected', b === t); }); $$('[data-dbody]', drawer).forEach(function (b) { b.hidden = b.dataset.dbody !== t.dataset.d; }); }
    });
  }
  var ms = $('#msearch');
  if (ms) ms.addEventListener('click', function () { var r = $('#mrow'); r.hidden = !r.hidden; if (!r.hidden) $('#q2').focus(); });

  /* search panel: brands and popular pieces at rest, predictive results while typing */
  var sp = $('#spanel'), popularDone = false, sTimer;
  function showSearch(q) {
    if (!sp) return;
    if (hdr) html.style.setProperty('--hdr-b', Math.max(0, hdr.getBoundingClientRect().bottom) + 'px');
    sp.hidden = false;
    var rest = $('#spanel-rest'), res = $('#spanel-results');
    if (!popularDone) {
      popularDone = true;
      var box = $('[data-popular]', sp);
      fetchSection(box.dataset.popular, 'fig-cards').then(function (d) {
        box.innerHTML = $$('.card', d).slice(0, 10).map(function (c) {
          var img = $('img', c);
          return '<a class="scard" href="' + $('a.ph', c).getAttribute('href') + '"><span>' + (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : '') + '</span><b>' + $('.c-brand', c).textContent + '</b><i>' + $('.c-name', c).textContent + '</i>' + $('.c-price .now', c).textContent + '</a>';
        }).join('');
      });
    }
    q = (q || '').trim();
    if (!q) { rest.hidden = false; res.hidden = true; return; }
    clearTimeout(sTimer);
    sTimer = setTimeout(function () {
      fetch(sectionUrl(R.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=last', 'fig-predictive'))
        .then(function (r) { return r.text(); })
        .then(function (t) { res.innerHTML = t; rest.hidden = true; res.hidden = false; });
    }, 180);
  }
  ['#q', '#q2'].forEach(function (s) {
    var inp = $(s);
    if (!inp) return;
    inp.addEventListener('focus', function () { showSearch(inp.value); });
    inp.addEventListener('input', function () { showSearch(inp.value); });
  });
  document.addEventListener('click', function (e) { if (sp && !e.target.closest('#spanel') && !e.target.closest('.search')) sp.hidden = true; });

  /* ── rails ────────────────────────────────────────── */
  function wireRail(r) {
    if (r.dataset.wired) return;
    r.dataset.wired = 1;
    var tr = $('[data-track]', r);
    if (!tr) return;
    var step = function () { var c = tr.children[0]; return c ? c.getBoundingClientRect().width + 16 : 300; };
    $$('[data-prev],[data-next]', r).forEach(function (b) { b.addEventListener('click', function () { tr.scrollBy({ left: DIR * (b.hasAttribute('data-next') ? 1 : -1) * step() * (innerWidth < 760 ? 1 : 2), behavior: 'smooth' }); }); });
    var pr = $('[data-progress]', r);
    if (pr) {
      var paint = function () { var m = tr.scrollWidth - tr.clientWidth; pr.style.setProperty('--p', m > 0 ? Math.abs(tr.scrollLeft) / m : 0); pr.style.setProperty('--w', Math.min(1, tr.clientWidth / Math.max(1, tr.scrollWidth))); };
      tr.addEventListener('scroll', paint, { passive: true });
      addEventListener('resize', paint);
      paint();
    }
  }
  function putCards(rail, cards) {
    var seen = {};
    cards = cards.filter(function (c) { if (seen[c.dataset.id]) return false; seen[c.dataset.id] = 1; return true; });
    if (cards.length < 2) return;
    var tr = $('[data-track]', rail);
    cards.slice(0, 14).forEach(function (c) { tr.appendChild(c); });
    paintWish(rail);
    paintSwatches(rail);
    rail.hidden = false;
    rail.dataset.wired = '';
    wireRail(rail);
  }
  var viewed = (store('fig-viewed') || []).filter(function (x) { return x && x.h; });
  /* What a Labesny piece is worn with, by its cat: tag (the AW26 master files' web categories).
     Lingerie sells in sets, so a bra leads to panties and a panty to bras — and the same brand in the
     same colour is tried first, because that is the matching set. Night and homewear leads to
     slippers and robes; clothing to what completes an outfit. A category not listed here falls back
     to Shopify's related products. */
  var COMPLEMENT = {
    bras: ['panties', 'panty-packs', 'shapewear'], panties: ['bras', 'panty-packs'], 'panty-packs': ['bras', 'panties'],
    body: ['panties', 'sleep-and-homewear'], corsetry: ['panties', 'fine-lingerie'], shapewear: ['bras', 'panties'],
    'fine-lingerie': ['sleep-and-homewear', 'panties', 'bras'], swimwear: ['accessories', 'swimwear'],
    'sleep-and-homewear': ['accessories', 'sleep-and-homewear'], sleepwear: ['accessories', 'sleepwear'], loungewear: ['accessories', 'loungewear'],
    pyjamas: ['accessories', 'slippers'], accessories: ['sleep-and-homewear', 'panties'],
    tops: ['trousers', 'leggings', 'skirts', 'jackets'], 't-shirts': ['trousers', 'jeans', 'pants', 'sweaters'], blouses: ['trousers', 'skirts'],
    shirts: ['trousers', 'pants', 'jeans', 'sweaters'], sweaters: ['trousers', 'pants', 'jeans', 'scarves'], pullover: ['trousers', 'pants', 'jeans', 'scarves'],
    cardigans: ['tops', 't-shirts', 'trousers'], sweatshirts: ['trousers', 'pants', 'joggers', 'jeans'], 'full-zip-sweatshirt': ['t-shirts', 'pants', 'jeans'],
    trousers: ['tops', 't-shirts', 'sweaters', 'shirts'], pants: ['t-shirts', 'shirts', 'sweaters', 'polos'], jeans: ['t-shirts', 'shirts', 'sweaters'],
    'denim-long': ['t-shirts', 'sweaters', 'shirts'], leggings: ['tops', 'sweatshirts', 't-shirts'], joggers: ['sweatshirts', 't-shirts'], skirts: ['tops', 'blouses', 'sweaters'],
    dresses: ['jackets', 'coats', 'scarves'], jumpsuits: ['jackets', 'blazers'], rompers: ['jackets'],
    jackets: ['sweaters', 't-shirts', 'trousers', 'jeans'], coats: ['sweaters', 'scarves', 'trousers'], blazers: ['tops', 'trousers', 'shirts'],
    'padded-jacket': ['sweaters', 'scarves', 'caps'], 'padded-vest': ['sweatshirts', 'shirts'], capes: ['sweaters', 'trousers'],
    polos: ['pants', 'jeans', 'shorts'], boxers: ['socks', 't-shirts'], socks: ['boxers'], scarves: ['coats', 'jackets', 'sweaters'],
    caps: ['jackets', 'sweatshirts'], hats: ['jackets', 'scarves'], gloves: ['coats', 'scarves'], vests: ['shirts', 'pants']
  };
  function cardsFrom(url) { return fetchSection(url, 'fig-cards').then(function (d) { return $$('.card', d); }).catch(function () { return []; }); }
  /* The colour is the part of the title after " - " ("Push-up Bra - Black"), handleized. */
  function colourOf(card) { var n = (($('.c-name', card) || {}).textContent || '').split(' - '); return n.length > 1 ? n[n.length - 1].trim().toLowerCase().replace(/[^a-z0-9]+/g, '-') : ''; }
  /* The set for one piece: the brand's own pieces in the categories it is worn with (matching colour
     first), then the department's. ctx carries cat, dh, vendor, colour and id, from data- attributes. */
  function setCards(ctx) {
    var cats = COMPLEMENT[ctx.cat] || [];
    if (!cats.length) return Promise.resolve([]);
    var urls = [];
    /* 3 Nov (Dan): suggestions are the same brand only — no department top-up (it brought Tom Tailor under
       Celio), and a card whose brand is not the piece's own (a retired collection redirecting to a
       department page) is dropped */
    cats.forEach(function (c) { if (ctx.vendor) urls.push(ROOT + '/collections/' + ctx.dh + '-' + ctx.vendor + '-' + c); });
    var own = ((($('.p-brand') || {}).textContent) || '').trim().toLowerCase();
    var mine = function (c) { var b = (($('.c-brand', c) || {}).textContent || '').trim().toLowerCase(); return !own || b === own; };
    return Promise.all(urls.map(cardsFrom)).then(function (lists) {
      var brandCards = [].concat.apply([], lists).filter(mine);
      var same = brandCards.filter(function (c) { return ctx.colour && colourOf(c) === ctx.colour; });
      var out = same.concat(brandCards), seen = {};
      seen[String(ctx.id || ctx.first || '')] = 1;
      return out.filter(function (c) { if (seen[c.dataset.id]) return false; seen[c.dataset.id] = 1; return true; });
    });
  }
  function complementCards(dh, cat, exclude) {
    var pdp = $('[data-pdp]');
    var ctx = pdp ? pdp.dataset : { dh: dh, cat: cat, id: exclude };
    return setCards(ctx);
  }
  function fillRail(rail) {
    var kind = rail.dataset.fill, pid = rail.dataset.product;
    if (kind === 'viewed') {
      var list = viewed.filter(function (v) { return String(v.id) !== String(pid); }).slice(0, 12);
      if (!list.length) return;
      Promise.all(list.map(function (v) { return fetchSection(ROOT + '/products/' + v.h, 'fig-card-one').then(function (d) { return $('.card', d); }); }))
        .then(function (cs) { putCards(rail, cs.filter(Boolean)); });
    } else if (kind === 'picked' || kind === 'related') {
      var seed = kind === 'related' ? pid : (viewed[0] && viewed[0].id);
      if (!seed) return;
      fetchSection(R.recs + '?product_id=' + seed + '&limit=12&intent=related', 'fig-recs').then(function (d) {
        var skip = viewed.map(function (v) { return String(v.id); });
        /* "Picked for you" follows the department the shopper is in: on a page with none of its own
           (About, 404, search) a Menswear visitor was shown women's robes (UI review N3). */
        var dep = rail.dataset.dept;
        if (!dep || dep === 'any') dep = document.body.dataset.dept;
        putCards(rail, $$('.card', d).filter(function (c) { return kind === 'related' || (skip.indexOf(c.dataset.id) < 0 && (!dep || dep === 'any' || c.dataset.dept === dep)); }));
      });
    } else if (kind === 'finish') {
      var pdp = $('[data-pdp]');
      if (!pdp) return;
      complementCards(pdp.dataset.dh, pdp.dataset.cat, pdp.dataset.id).then(function (cs) { putCards(rail, cs.slice(4)); });
    } else if (kind === 'cartset') {
      var inCart = (rail.dataset.ids || '').split(',');
      gapCards($('.cart-sum .nudge-box'), inCart).then(function (g) {
        if (g) { $('.recs-title', rail).textContent = g.title; putCards(rail, g.cards); return; }
        setCards(rail.dataset).then(function (cs) { putCards(rail, cs.filter(function (c) { return inCart.indexOf(c.dataset.id) < 0; })); });
      });
    }
  }

  /* ── collection: density, filters, load more ───────── */
  var plp = $('[data-plp]');
  if (plp) {
    var secId = (plp.closest('.shopify-section') || {}).id;
    secId = secId ? secId.replace('shopify-section-', '') : '';
    var grid = $('#grid');
    var dens = store('fig-dens') || 4;
    var paintDens = function () {
      if (grid) grid.classList.toggle('two', dens === 2);
      $$('[data-dens]').forEach(function (b) { b.setAttribute('aria-pressed', Number(b.dataset.dens) === dens); });
    };
    paintDens();
    plp.addEventListener('click', function (e) {
      var d = e.target.closest('[data-dens]');
      if (d) { dens = Number(d.dataset.dens); store('fig-dens', dens); paintDens(); }
      if (e.target.closest('[data-fopen]')) { $('#fd').hidden = false; lock(true); }
      if (e.target.closest('#fd [data-x]')) { $('#fd').hidden = true; lock(false); }
    });
    var form = $('#fform'), vt;
    /* Every choice applies at once (Ali Dagher, 11 October: "Filter and sort not updating when you
       switch between the buttons"): the pieces behind the drawer, the applied-filter chips, the item
       counts, and the drawer's own options, whose counts follow what is chosen. The sections that
       were open stay open; the URL follows, so Back and sharing keep working. */
    var applyUrl = function (url, whole) {
      fetchSection(url, secId).then(function (d) {
        var g = $('#grid', d);
        var n = g ? g.dataset.count : 0;
        if (form) $('[data-view]', form).textContent = tr('view_results', { n: n });
        var res = $('[data-results]', plp), nres = $('[data-results]', d);
        if (res && nres) { res.innerHTML = nres.innerHTML; grid = $('#grid'); paintDens(); if (grid) { paintWish(grid); paintSwatches(grid); } }
        var nitems = $('[data-items]', d);
        if (nitems) $$('[data-items]', plp).forEach(function (el) { el.textContent = nitems.textContent; });
        var napplied = $('[data-applied]', d), applied = $('[data-applied]', plp);
        if (applied && napplied) applied.innerHTML = napplied.innerHTML;
        /* The category tiles and the pills in the sticky bar follow: each tile's link and pressed state
           come from the new page, matched by name, so its photo stays as it is (24 Oct). */
        /* Sale and the offer chips change which tiles there are, so the title area, the offer chips and
           the tile row are taken whole from the new page (24 Oct); a tile only changes which is pressed. */
        if (whole) {
          var hero = $('.plp-hero', plp);
          ['.plp-hero', '.plp-deal', '.subcats'].forEach(function (sel) {
            var o = $(sel, plp), n = $(sel, d);
            if (o && n) o.innerHTML = n.innerHTML;
            else if (o) o.innerHTML = '';
            else if (n && hero) hero.insertAdjacentElement('afterend', n);
          });
          fillTiles(plp);
        }
        var label = function (a) { var b = a.querySelector('b'); return (b ? b.textContent : a.textContent).trim(); };
        var fresh = {};
        $$('.subcats a.subcat', d).forEach(function (a) { fresh[label(a)] = a; });
        $$('.subcats a.subcat, [data-subnav] a', plp).forEach(function (a) {
          var n = fresh[label(a)];
          if (!n) return;
          a.setAttribute('href', n.getAttribute('href'));
          if (n.hasAttribute('aria-current')) a.setAttribute('aria-current', 'page'); else a.removeAttribute('aria-current');
        });
        var nform = $('#fform', d);
        if (form && nform) form.setAttribute('action', nform.getAttribute('action'));
        var fbtn = $('.fbtn', plp), nfbtn = $('.fbtn', d);
        if (fbtn && nfbtn) fbtn.innerHTML = nfbtn.innerHTML;
        var sel = $('[data-sort]', plp), nsel = $('[data-sort]', d);
        if (sel && nsel) sel.value = nsel.value;
        var body = form && $('.fd-body', form), nbody = $('#fform .fd-body', d);
        if (body && nbody && !body.contains(document.activeElement && document.activeElement.type === 'text' ? document.activeElement : null)) {
          var key = function (el) { return (el.querySelector('summary').firstChild || {}).textContent; };
          var open = $$('details', body).filter(function (x) { return x.open; }).map(key);
          var top = body.scrollTop;
          $$('details', nbody).forEach(function (x) { x.open = open.indexOf(key(x)) >= 0; });
          body.innerHTML = nbody.innerHTML;
          paintSwatches(body);
          body.scrollTop = top;
        }
        try { history.replaceState(null, '', url); } catch (e) {}
      });
    };
    if (form) {
      form.addEventListener('change', function () {
        clearTimeout(vt);
        vt = setTimeout(function () {
          var p = new URLSearchParams(new FormData(form));
          $$('input', form).forEach(function (i) { if (i.type !== 'checkbox' && i.type !== 'radio' && !i.value) p.delete(i.name); });
          applyUrl(form.getAttribute('action') + '?' + p.toString());
        }, 250);
      });
      form.addEventListener('submit', function () { $$('input', form).forEach(function (i) { if (i.type !== 'checkbox' && i.type !== 'radio' && !i.value) i.disabled = true; }); });
      /* Price bands fill the from / to fields and apply; pressing the chosen band again clears it. */
      form.addEventListener('click', function (e) {
        var pb = e.target.closest('[data-pmax]');
        if (pb) {
          var on = pb.getAttribute('aria-pressed') === 'true';
          $('#pmin', form).value = on ? '' : pb.dataset.pmin;
          $('#pmax', form).value = on ? '' : pb.dataset.pmax;
          form.dispatchEvent(new Event('change'));
        }
        var fm = e.target.closest('[data-fmore]');
        if (fm) {
          var box = fm.previousElementSibling, all = box.classList.toggle('all');
          fm.textContent = all ? fm.dataset.less : fm.dataset.all;
        }
      });
    }
    /* Sort beside the Filter button drives the drawer's sort radios (UI review F4). */
    var sortSel = $('[data-sort]', plp);
    if (sortSel && form) sortSel.addEventListener('change', function () {
      var r = $('input[name="sort_by"][value="' + sortSel.value + '"]', form);
      if (r) { r.checked = true; form.dispatchEvent(new Event('change')); }
    });
    /* An applied-filter chip, or Clear all, is the URL without it: applied in place. */
    plp.addEventListener('click', function (e) {
      var u = e.target.closest('[data-unfilter]');
      if (u) { e.preventDefault(); applyUrl(u.getAttribute('href')); }
    });
    /* A category tile, or its pill in the sticky bar, that narrows this same collection (a type
       filter, a cat:/subcat: tag, a Benetton age group) filters the pieces in place, as the filters
       do; pressed again it shows the whole collection (Dan, 24 Oct: "it should be filter system …
       when clicking on it back, it should remove the filter"). A tile for another page still opens it. */
    var collBase = function (p) { var m = p.match(/^(.*?\/collections\/[^\/?#]+)/); return m ? m[1] : null; };
    plp.addEventListener('click', function (e) {
      var a = e.target.closest('.subcats a.subcat, [data-subnav] a, .deal-chip, .brand-sale a');
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var whole = !!a.closest('.deal-chip, .brand-sale');
      var u = new URL(a.href, location.href);
      if (u.origin !== location.origin || collBase(u.pathname) !== collBase(location.pathname)) return;
      e.preventDefault();
      var on = a.getAttribute('aria-current') === 'page';
      applyUrl(on ? collBase(location.pathname) : u.pathname + u.search, whole);
      var g = $('#grid');
      if (g && g.getBoundingClientRect().top < 0) window.scrollTo({ top: g.getBoundingClientRect().top + scrollY - 160, behavior: 'smooth' });
    });
  }
  /* Load more, on collections and search */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-more]');
    if (!b) return;
    var more = $('#more'), g = $('#grid');
    b.disabled = true;
    b.textContent = tr('loading');
    fetchSection(b.dataset.more, 'fig-cards').then(function (d) {
      var box = $('.cards', d);
      $$('.card', d).forEach(function (c) { g.appendChild(c); });
      paintWish(g);
      paintSwatches(g);
      var seen = $$('.card', g).length, total = Number(more.dataset.total);
      $('[data-seen-n]', more).textContent = seen;
      $('.more-bar i', more).style.width = Math.min(100, seen / total * 100) + '%';
      if (box && box.dataset.next) { b.dataset.more = box.dataset.next; b.disabled = false; b.textContent = tr('load_more'); } else b.remove();
    });
  });

  /* ── product page ─────────────────────────────────── */
  var pdpEl = $('[data-pdp]');
  if (pdpEl) {
    var variants = JSON.parse($('[data-pvariants]').textContent);
    /* A size loaded at 0 KD is never sold for nothing: it shows as not available (Celio, Benetton, 11 October). */
    variants.forEach(function (v) { if (!(v.price > 0)) v.available = false; });
    var braErr = null;
    var formP = $('#pform');
    // One track of photos: swiped on phones, switched by the thumbnails on desktop.
    var slides = $('[data-slides]'), prog = $('[data-prog]'), allThumbs = $$('[data-th]'), slideAt = 0;
    var thumbs = allThumbs.filter(function (t) { return !t.hidden; });
    var vis = function () { return slides ? $$('.slide', slides).filter(function (s) { return !s.hidden; }) : []; };
    var phone = function () { return matchMedia('(max-width: 1111px)').matches; };
    /* Only the chosen colour's photos (Dan, 27 Oct). Each photo carries its colour in data-c (the
       section works it out from the alt text, the variant photo, the file name and the order); a photo
       with none goes with every colour, and a colour with no photo of its own shows them all. */
    var galC = slides ? slides.dataset.csel || '' : '';
    var showColour = function (ch) {
      if (!slides || !ch || ch === galC) return false;
      var all = $$('.slide', slides);
      var own = all.some(function (s) { return s.dataset.c === ch; });
      if (!own && !galC) return false;
      galC = own ? ch : '';
      all.forEach(function (s, k) {
        s.hidden = !!(own && s.dataset.c && s.dataset.c !== ch);
        s.style.order = '';
        if (allThumbs[k]) { allThumbs[k].hidden = s.hidden; allThumbs[k].removeAttribute('aria-current'); }
      });
      thumbs = allThumbs.filter(function (t) { return !t.hidden; });
      var n = vis().length;
      slides.dataset.n = n;
      if (prog) { prog.style.width = 100 / Math.max(n, 1) + '%'; prog.parentNode.hidden = n < 2; }
      slideAt = -1;
      return true;
    };
    var goSlide = function (i, smooth) {
      if (!slides || i < 0) return;
      /* Desktop shows the photos two across down the page (UI review P3), so the chosen colour's
         photo moves to the first place instead of the track scrolling to it. */
      if (!phone()) {
        vis().forEach(function (s, k) { s.style.order = k === i ? -1 : ''; });
        slideAt = i;
        return;
      }
      $$('.slide', slides).forEach(function (s) { s.style.order = ''; });
      slides.scrollTo({ left: DIR * i * slides.clientWidth, behavior: smooth && phone() ? 'smooth' : 'auto' });
      markSlide(i);
    };
    var markSlide = function (i) {
      if (i === slideAt && thumbs[i] && thumbs[i].hasAttribute('aria-current')) return;
      slideAt = i;
      thumbs.forEach(function (x, k) { x.toggleAttribute('aria-current', k === i); });
      var t = thumbs[i], row = t && t.parentNode;
      if (row && phone()) row.scrollTo({ left: DIR > 0 ? t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2 : -(row.scrollWidth - t.offsetLeft - t.offsetWidth - (row.clientWidth - t.offsetWidth) / 2), behavior: 'smooth' });
    };
    if (slides) slides.addEventListener('scroll', function () {
      var w = slides.clientWidth || 1;
      if (prog) prog.style.transform = 'translateX(' + (slides.scrollLeft / w * 100) + '%)';
      markSlide(Math.round(Math.abs(slides.scrollLeft) / w));
    }, { passive: true });
    addEventListener('resize', function () { goSlide(slideAt); });
    var sel = [];
    var groups = $$('[data-opt]', pdpEl);
    groups.forEach(function (g) { var on = $('[aria-pressed="true"]', g); sel[Number(g.dataset.opt)] = on ? on.dataset.val : null; });
    variants[0].options.forEach(function (_, i) { if (sel[i] === undefined) sel[i] = variants.length === 1 ? variants[0].options[i] : null; });
    groups.forEach(function (g) { var vals = $$('[data-val]', g); if (vals.length === 1) { sel[Number(g.dataset.opt)] = vals[0].dataset.val; vals[0].setAttribute('aria-pressed', 'true'); } });
    var current = function () { return variants.find(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); }); };
    var paint = function () {
      groups.forEach(function (g) {
        var i = Number(g.dataset.opt);
        $$('[data-val]', g).forEach(function (b) {
          b.setAttribute('aria-pressed', sel[i] === b.dataset.val);
          // A size is crossed out when no variant with it, and the other chosen options, is in stock.
          var ok = variants.some(function (v) { return v.available && v.options[i] === b.dataset.val && v.options.every(function (o, k) { return k === i || sel[k] == null || g.hasAttribute('data-pick') === false || sel[k] === o; }); });
          if (g.hasAttribute('data-pick')) b.disabled = !ok;
        });
        var lbl = $('[data-oname="' + i + '"]', pdpEl);
        if (lbl) lbl.textContent = sel[i] ? String(sel[i]).toLowerCase() : '';
      });
      var v = current();
      var add = $('[data-add]', pdpEl);
      var any = variants.some(function (x) { return x.available; });
      var cgr = $('.swatches[data-opt]', pdpEl);
      if (cgr) {
        var cb = $$('[data-val]', cgr).find(function (b) { return b.dataset.val === sel[Number(cgr.dataset.opt)]; });
        if (cb && showColour(cb.dataset.ch)) goSlide(0);
      }
      if (v) {
        $('[data-vid]', formP).value = v.id;
        /* only the two price labels: product cards carry data-price too, as a number, not a label */
        $$('.p-price[data-price], .sb-p[data-price]').forEach(function (p) { p.textContent = money(v.price); });
        var was = $('[data-was]', pdpEl);
        if (v.compare_at_price > v.price) { was.hidden = false; was.innerHTML = '<s>' + money(v.compare_at_price) + '</s><em>' + tr('you_save', { amount: money(v.compare_at_price - v.price), pct: Math.round((1 - v.price / v.compare_at_price) * 100) }) + '</em>'; } else was.hidden = true;
        var sku = $('[data-sku]', pdpEl);
        if (sku && (v.barcode || v.sku)) sku.textContent = v.barcode || v.sku;
        var rc = $('[data-ref-colour]', pdpEl), cg = $('.swatches[data-opt]', pdpEl);
        if (rc && cg) rc.textContent = v.options[Number(cg.dataset.opt)];
        add.textContent = v.available ? tr('add') : tr('sold_out');
        add.disabled = !v.available;
        promoPrice = v.price;
        smartPromo();
        if (v.featured_media) goSlide(vis().map(function (s) { return s.dataset.mid; }).indexOf(String(v.featured_media.id)), true);
      } else {
        add.textContent = any ? tr('select_size') : tr('sold_out');
        add.disabled = !any;
      }
      /* Shopify disables Buy it now until the form has a variant, and a disabled button swallows
         the tap. A cover over it catches the tap and points at the sizes instead. */
      var nowEl = $('div.now', pdpEl);
      if (nowEl) nowEl.classList.toggle('is-locked', !v && any);
    };
    paint();
    smartPromo();
    /* ── bra sizes: Band and Cup, in the shopper's own size system ──
       Every brand writes bras in its own system — Etam and Women'secret French bands (85 = EU 70),
       Hunkemöller EU with the cup first (C75), La Vie en Rose US (34DD) — in one Size option. Here a
       bra's sizes become two rows, Band and Cup, as bevava shows them, and a switch writes them in
       the brand's system, EU, FR, UK or US; the choice is remembered for every bra on the site. The
       Size option underneath is untouched: a band and a cup pick the variant they name. */
    (function () {
      var g = $('[data-opt][data-pick]', pdpEl);
      if (!g) return;
      var oi = Number(g.dataset.opt), sys = pdpEl.dataset.braSys || 'EU';
      var US2EU = { 28: 60, 30: 65, 32: 70, 34: 75, 36: 80, 38: 85, 40: 90, 42: 95, 44: 100, 46: 105 }, EU2UK = {};
      Object.keys(US2EU).forEach(function (k) { EU2UK[US2EU[k]] = Number(k); });
      var UK = { A: 'A', B: 'B', C: 'C', D: 'D', E: 'DD', F: 'E', G: 'F', H: 'FF' }, US = { A: 'A', B: 'B', C: 'C', D: 'D', E: 'DD', F: 'DDD', G: 'G', H: 'H' };
      var USC = { A: 'A', B: 'B', C: 'C', D: 'D', DD: 'E', E: 'E', DDD: 'F', F: 'F', G: 'G', H: 'H' };
      var parse = function (raw) {
        var v = String(raw).toUpperCase().replace(/\s*CUP\s*/, '').replace(/\s+/g, ''), m = v.match(/^(\d{2,3})([A-H]{1,3})$/), b, c;
        if (m) { b = Number(m[1]); c = m[2]; } else if ((m = v.match(/^([A-H]{1,3})(\d{2,3})$/))) { b = Number(m[2]); c = m[1]; } else return null;
        var eu = b;
        if (sys === 'FR') { if (b < 80) return null; eu = b - 15; } else if (sys === 'US') { if (!US2EU[b]) return null; eu = US2EU[b]; c = USC[c] || null; } else if (b < 60) return null;
        if (!c || c.length > 1) return null;
        return { raw: raw, band: eu, cup: c };
      };
      var vals = $$('[data-val]', g).map(function (b) { return b.dataset.val; });
      var ok = vals.map(parse).filter(Boolean);
      if (ok.length < 2 || ok.length < vals.length * 0.7) return;
      var bands = [], cups = [];
      ok.forEach(function (x) { if (bands.indexOf(x.band) < 0) bands.push(x.band); if (cups.indexOf(x.cup) < 0) cups.push(x.cup); });
      if (bands.length < 2 && cups.length < 2) return;
      bands.sort(function (a, b) { return a - b; }); cups.sort();
      var SYS = ['brand', 'EU', 'FR', 'UK', 'US'];
      var pref = store('lab-bra-sys') || 'brand';
      var bandLabel = function (b, s) {
        if (s === 'brand') s = sys;
        if (s === 'FR') return String(b + 15);
        if (s === 'UK' || s === 'US') return EU2UK[b] ? String(EU2UK[b]) : String(b);
        return String(b);
      };
      var cupLabel = function (c, s) { if (s === 'brand') s = sys; return s === 'UK' ? UK[c] : s === 'US' ? US[c] : c; };
      var sysName = function (s) { return s === 'brand' ? tr('bra_brand', { sys: sys }) : s; };
      var box = document.createElement('div');
      box.className = 'bra-pick';
      box.innerHTML = '<div class="bra-sys" role="group" aria-label="' + tr('bra_sizes_in') + '"><span>' + tr('bra_sizes_in') + '</span>' + SYS.map(function (s) { return '<button type="button" data-bsys="' + s + '">' + sysName(s) + '</button>'; }).join('') + '</div>' +
        '<p class="p-lbl">' + tr('bra_band') + ': <b data-bl></b></p><div class="sizes bra-row" data-brow="band">' + bands.map(function (b) { return '<button type="button" data-band="' + b + '"></button>'; }).join('') + '</div>' +
        '<p class="p-lbl">' + tr('bra_cup') + ': <b data-cl></b></p><div class="sizes bra-row" data-brow="cup">' + cups.map(function (c) { return '<button type="button" data-cup="' + c + '"></button>'; }).join('') + '</div>' +
        '<p class="bra-eq" data-beq hidden></p>';
      var lbl = g.previousElementSibling;
      g.parentNode.insertBefore(box, g);
      g.hidden = true;
      if (lbl && lbl.classList.contains('p-lbl')) lbl.hidden = true;
      var pickB = null, pickC = null;
      var cur = parse(sel[oi] || '');
      if (cur) { pickB = cur.band; pickC = cur.cup; }
      var avail = function (band, cup) {
        return variants.some(function (v) {
          if (!v.available) return false;
          var x = parse(v.options[oi]);
          if (!x || (band != null && x.band !== band) || (cup != null && x.cup !== cup)) return false;
          return v.options.every(function (o, k) { return k === oi || sel[k] == null || sel[k] === o; });
        });
      };
      var draw = function () {
        $$('[data-bsys]', box).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bsys === pref); });
        $$('[data-band]', box).forEach(function (b) { var n = Number(b.dataset.band); b.textContent = bandLabel(n, pref); b.setAttribute('aria-pressed', n === pickB); b.disabled = !avail(n, null); });
        $$('[data-cup]', box).forEach(function (b) { var c = b.dataset.cup; b.textContent = cupLabel(c, pref); b.setAttribute('aria-pressed', c === pickC); b.disabled = !avail(pickB, c); });
        $('[data-bl]', box).textContent = pickB != null ? bandLabel(pickB, pref) : '';
        $('[data-cl]', box).textContent = pickC ? cupLabel(pickC, pref) : '';
        /* the chosen size in every system, so nobody has to convert in their head */
        var eq = $('[data-beq]', box);
        if (pickB != null && pickC) {
          eq.innerHTML = ['EU', 'FR', 'UK', 'US'].map(function (s) { return '<span><small>' + s + '</small> ' + bandLabel(pickB, s) + cupLabel(pickC, s) + '</span>'; }).join('');
          eq.hidden = false;
        } else eq.hidden = true;
      };
      var choose = function () {
        var hit = ok.find(function (x) { return x.band === pickB && x.cup === pickC; });
        sel[oi] = hit ? hit.raw : null;
        box.classList.remove('err');
        $('[data-err]', pdpEl).textContent = '';
        paint();
        draw();
      };
      box.addEventListener('click', function (e) {
        var s = e.target.closest('[data-bsys]');
        if (s) { pref = s.dataset.bsys; store('lab-bra-sys', pref); draw(); return; }
        var b = e.target.closest('[data-band]');
        if (b && !b.disabled) { pickB = Number(b.dataset.band); if (pickC && !avail(pickB, pickC)) pickC = null; choose(); return; }
        var c = e.target.closest('[data-cup]');
        if (c && !c.disabled) { pickC = c.dataset.cup; choose(); }
      });
      /* a colour change re-checks what is in stock; a failed Add to bag points at the rows */
      pdpEl.addEventListener('click', function (e) { if (e.target.closest('.swatches [data-val]')) setTimeout(draw, 0); });
      braErr = function () {
        if (sel[oi] != null) return false;
        box.classList.add('err');
        box.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return true;
      };
      draw();
    })();
    pdpEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-opt] [data-val]');
      if (b && !b.disabled) { sel[Number(b.closest('[data-opt]').dataset.opt)] = b.dataset.val; $$('[data-pick]').forEach(function (g) { g.classList.remove('err'); }); $('[data-err]', pdpEl).textContent = ''; paint(); }
      var th = e.target.closest('[data-th]');
      if (th) goSlide(thumbs.indexOf(th), true);
      if (e.target.closest('#mainimg')) { var sl = e.target.closest('.slide'); if (sl && !phone()) slideAt = vis().indexOf(sl); zoom(); }
      if (e.target.closest('[data-sg]')) { $('#sgd').hidden = false; lock(true); }
    });
    var submit = function (e) {
      if (e) e.preventDefault();
      if (braErr && !current() && braErr()) { $('[data-err]', pdpEl).textContent = tr('pick_size'); return; }
      var v = current();
      if (!v) {
        $$('[data-pick]').forEach(function (g) { if (sel[Number(g.dataset.opt)] == null) g.classList.add('err'); });
        $('[data-err]', pdpEl).textContent = tr('pick_size');
        var first = $('[data-pick].err');
        if (first) first.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      addToBag([{ id: v.id, quantity: 1 }]);
    };
    formP.addEventListener('submit', submit);
    var nowBox = $('div.now', pdpEl);
    if (nowBox) nowBox.addEventListener('click', function (e) {
      if (nowBox.classList.contains('is-locked')) { e.preventDefault(); submit(); }
    });
    var add2 = $('[data-add2]');
    if (add2) add2.addEventListener('click', submit);
    var sgd = $('#sgd');
    if (sgd) sgd.addEventListener('click', function (e) { if (e.target.closest('[data-x]')) { sgd.hidden = true; lock(false); } });
    var zoom = function () {
      var z = document.createElement('div');
      z.className = 'zoom';
      z.innerHTML = '<button type="button" class="zoom-x" aria-label="' + tr('close') + '">✕</button>' + vis().map(function (s) { return '<img src="' + s.dataset.z + '" alt="" loading="lazy">'; }).join('');
      document.body.appendChild(z);
      var zi = $$('img', z)[slideAt];
      if (zi) zi.scrollIntoView();
      lock(true);
      z.addEventListener('click', function () { z.remove(); lock(false); });
    };
    var sticky = $('#sticky');
    /* The bar takes the top of the screen, so the header steps aside while it shows and comes back
       when the main button is in view again — the two never stack (Labesny, 9 October). */
    if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(function (en) {
      var on = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
      sticky.classList.toggle('on', on);
      document.body.classList.toggle('sb-on', on);
    }).observe($('#buy'));
    fillXsell();
    // Remember the visit for "You viewed" and "Picked for you".
    viewed = viewed.filter(function (x) { return String(x.id) !== pdpEl.dataset.id; });
    viewed.unshift({ h: pdpEl.dataset.handle, id: pdpEl.dataset.id });
    store('fig-viewed', viewed.slice(0, 24));
    viewed = viewed.slice(1);
    buildBundle(variants);
  }

  /* Buy it together: this piece and two it is worn with, each with its own size. */
  function buildBundle(mainVariants) {
    var box = $('[data-bundle]');
    if (!box || !pdpEl) return;
    complementCards(pdpEl.dataset.dh, pdpEl.dataset.cat, pdpEl.dataset.id).then(function (cs) {
      var picks = cs.slice(0, 2);
      if (!picks.length) return;
      var mainImg = $('#mainimg img');
      var items = [{ main: true, title: $('.p-title').textContent, brand: $('.p-brand').textContent, img: mainImg ? mainImg.src : '', variants: mainVariants.map(function (v) { return { id: v.id, o: v.options, a: v.available, p: v.price }; }) }]
        .concat(picks.map(function (c) { var img = $('img', c); return { price: Number(c.dataset.price), title: $('.c-name', c).textContent, brand: $('.c-brand', c).textContent, img: img ? img.src : '', variants: cardVariants(c).map(function (v) { return { id: v.id, o: v.o, a: v.a, p: Number(c.dataset.price) }; }), href: $('a.ph', c).getAttribute('href') }; }));
      $('[data-bundle-items]', box).innerHTML = items.map(function (it, i) {
        var opts = it.variants.filter(function (v) { return v.a; }).map(function (v) { return '<option value="' + v.id + '" data-p="' + v.p + '">' + v.o.join(' / ') + '</option>'; }).join('');
        return (i ? '<span class="b-plus">+</span>' : '') + '<label class="b-item"><input type="checkbox" checked data-bi="' + i + '"' + (i ? '' : ' disabled') + '><img src="' + it.img + '" alt=""><div><b>' + it.brand + '</b><span>' + it.title + '</span>' +
          (i ? '<select data-bs="' + i + '" aria-label="' + tr('size_for') + ' ' + it.title.replace(/"/g, '') + '"><option value="">' + tr('select_size') + '</option>' + opts + '</select>' : '<small style="color:var(--grey)">' + tr('size_above') + '</small>') + '</div></label>';
      }).join('');
      var mainPrice = function () { var v = mainVariants.find(function (x) { return String(x.id) === $('[data-vid]').value; }); return v ? v.price : mainVariants[0].price; };
      var total = function () {
        var sum = mainPrice();
        $$('[data-bi]', box).forEach(function (cb) { var i = Number(cb.dataset.bi); if (i && cb.checked) sum += items[i].price; });
        $('[data-bundle-total]', box).textContent = tr('total') + ' ' + money(sum);
      };
      box.addEventListener('change', total);
      total();
      box.hidden = false;
      $('[data-bundle-add]', box).addEventListener('click', function () {
        var err = $('[data-bundle-err]', box);
        err.textContent = '';
        var mainOk = !$$('[data-pick]').some(function (g) { return !$('[aria-pressed="true"]', g); });
        if (!mainOk) { err.textContent = tr('pick_main'); $('#buy').scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
        var list = [{ id: Number($('[data-vid]').value), quantity: 1 }];
        var missing = false;
        $$('[data-bi]', box).forEach(function (cb) {
          var i = Number(cb.dataset.bi);
          if (!i || !cb.checked) return;
          var s = $('[data-bs="' + i + '"]', box);
          if (!s.value) missing = true; else list.push({ id: Number(s.value), quantity: 1 });
        });
        if (missing) { err.textContent = tr('pick_each'); return; }
        addToBag(list);
      });
    });
  }

  /* The gift tiers on the product page, told from the shopper's own bag: what adding this piece
     does for them. Shopify measures the bag's total before discounts against the tier, and takes
     the tier off this brand's pieces — so the message is about the bag, and about this brand. */
  var promoPrice = null, cartTotal = null;
  /* "Within reach": a gap of 10 KD or less, or no more than 20% of the tier's threshold. Prices are
     hundredths, so 10 KD is 1000. The same rule is in snippets/fig-promo-nudge for the bag. */
  var near = function (gap, spend) { return gap > 0 && (gap <= 1000 || gap * 100 <= spend * 20); };
  function smartPromo(fresh) {
    var box = $('[data-promo]');
    if (!box || !pdpEl) return;
    var tiers = box.dataset.promo.split(',').map(function (t) { var p = t.split(':'); return { spend: Number(p[0]) * 100, pct: Number(p[1]) }; }).sort(function (a, b) { return a.spend - b.spend; });
    var price = promoPrice != null ? promoPrice : Number(pdpEl.dataset.base || 0);
    /* Store credit counts this brand's full-price pieces only, and nothing when a discount code is
       on the bag (Moody, 13 Oct 2026): templates/cart.credit.liquid sums them the same way the bag
       does. A sale piece earns nothing, so its page says nothing about levels. */
    if (box.hasAttribute('data-sale')) { box.hidden = true; return; }
    var get = cartTotal != null && !fresh ? Promise.resolve(cartTotal) : fetch(R.cart + '?view=credit', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.code ? -1 : (c.brands[box.dataset.vendor] || 0); return cartTotal; });
    get.then(function (T) {
      if (T < 0) { box.hidden = true; return; }
      var A = T + price, brand = box.dataset.brand;
      /* the figures in bold; the words come from the locale files, which Shopify escapes */
      var B = function (x) { return '<b>' + x + '</b>'; };
      var reached = function (x) { var g = null; tiers.forEach(function (t) { if (x >= t.spend) g = t; }); return g; };
      var now = reached(T), after = reached(A);
      var next = tiers.filter(function (t) { return t.spend > A; })[0];
      /* Said only when it is worth saying (Labesny, 10 October): this piece unlocks a tier, or the
         next tier is within reach — 10 KD, or 20% of its threshold, whichever is larger. A shopper
         40 KD away is not shown an offer, and one who already has the top tier is not told again. */
      var msg = null;
      if (after && (!now || after.pct > now.pct)) {
        msg = tr('promo_unlocks', { pct: B(after.pct), brand: brand });
      } else if (next && near(next.spend - A, next.spend)) {
        msg = tr('promo_away', { amount: B(money(next.spend - A)), pct: B(next.pct), brand: brand });
      }
      $('[data-promo-live]', box).innerHTML = msg || '';
      box.hidden = !msg;
    }).catch(function () {});
  }

  /* "Complete the set", between the buttons and the description. Small
     cards, three each, with the photo, brand, name and price; the size is chosen on the piece's own
     page, which is one tap away. */
  function fillXsell() {
    var box = $('[data-xsell]');
    if (!box || !pdpEl) return;
    var ctx = pdpEl.dataset;
    var mini = function (c) {
      var img = $('img', c), href = $('a.ph', c).getAttribute('href');
      return '<a class="xs-card" href="' + href + '"><span>' + (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : '') + '</span><b>' + (($('.c-brand', c) || {}).textContent || '') + '</b><i>' + (($('.c-name', c) || {}).textContent || '') + '</i><em>' + (($('.c-price .now', c) || {}).textContent || '') + '</em></a>';
    };
    var put = function (kind, cards) {
      var sec = $('[data-xs="' + kind + '"]', box);
      cards = cards.filter(function (c) { return $('img', c); }).slice(0, 3);
      if (!cards.length) return;
      $('[data-xs-row]', sec).innerHTML = cards.map(mini).join('');
      sec.hidden = false; box.hidden = false;
    };
    setCards(ctx).then(function (cs) { put('set', cs); });
  }

  /* ── brands page ──────────────────────────────────── */
  var brail = $('[data-brail]');
  if (brail) {
    /* A brand's pieces, 96 a page with page numbers under them (Dan, 20 Oct: pages, not "Load more").
       The page replaces the grid and the pager; `jump` brings the shopper back to the top of the results. */
    var loadPage = function (panel, url, jump) {
      var res = $('[data-results]', panel);
      res.style.opacity = .35;
      return fetchSection(url, 'fig-cards-page').then(function (d) {
        var box = $('.cards', d), pg = $('.pager', d), old = $('.pager', panel);
        res.innerHTML = '';
        $$('.card', d).forEach(function (c) { res.appendChild(c); });
        if (old) old.remove();
        if (pg) res.insertAdjacentElement('afterend', pg);
        if (box) $('[data-rcount]', panel).textContent = tr('items', { n: box.dataset.count });
        res.style.opacity = '';
        panel.dataset.loaded = '1';
        paintWish(res);
        paintSwatches(res);
        if (jump) $('.bres-h', panel).scrollIntoView({ block: 'start' });
      });
    };
    var shown = function () { var p = $$('[data-panel]').filter(function (x) { return !x.hidden; })[0]; if (p && !p.dataset.loaded) loadPage(p, p.dataset.url); };
    var pick = function (slug) {
      var tab = $('[data-b="' + slug + '"]', brail) || $('[data-b]', brail);
      $$('[data-b]', brail).forEach(function (b) { b.setAttribute('aria-selected', b === tab); });
      $$('[data-panel]').forEach(function (p) { p.hidden = p.dataset.panel !== tab.dataset.b; });
      tab.scrollIntoView({ inline: 'center', block: 'nearest' });
      shown();
    };
    if (location.hash) pick(location.hash.slice(1)); else shown();
    brail.addEventListener('click', function (e) { var b = e.target.closest('[data-b]'); if (b) { history.replaceState(null, '', '#' + b.dataset.b); pick(b.dataset.b); } });
    addEventListener('hashchange', function () { pick(location.hash.slice(1)); });
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.ctile');
      var pa = e.target.closest('[data-panel] .pager a');
      if (!t && !pa) return;
      var panel = (t || pa).closest('[data-panel]');
      if (pa) { e.preventDefault(); loadPage(panel, pa.getAttribute('href'), true); return; }
      $$('.ctile', panel).forEach(function (x) { x.setAttribute('aria-pressed', x === t); });
      $('[data-rtitle]', panel).textContent = t.dataset.c ? t.dataset.cname : tr('everything_of', { name: $('.bpanel-h .display', panel).textContent });
      loadPage(panel, panel.dataset.url + (t.dataset.c ? '/' + t.dataset.c : ''));
    });
  }

  /* ── wishlist page ────────────────────────────────── */
  var wl = $('[data-wishlist]');
  if (wl) {
    var wg = $('[data-wgrid]', wl);
    wishReady.then(function () {
    if (!wish.length) $('[data-wempty]', wl).hidden = false;
    Promise.all(wish.map(function (h) { return fetchSection(ROOT + '/products/' + h, 'fig-card-one').then(function (d) { return $('.card', d); }); })).then(function (cs) {
      cs.filter(Boolean).forEach(function (c) { wg.appendChild(c); });
      if (!wg.children.length) $('[data-wempty]', wl).hidden = false;
      paintWish(wg);
      paintSwatches(wg);
    });
    });
  }

  /* ── the customer's profile ───────────────────────── */
  var acct = $('[data-acct]');
  if (acct) {
    var wishDone = false;
    var showTab = function (k) {
      $$('[data-at]', acct).forEach(function (b) { b.setAttribute('aria-selected', b.dataset.at === k); });
      $$('[data-ap]', acct).forEach(function (p) { p.hidden = p.dataset.ap !== k; });
      if (k === 'wish' && !wishDone) {
        wishDone = true;
        var g = $('[data-acct-wish]', acct);
        wishReady.then(function () {
        if (!wish.length) { $('[data-acct-wempty]', acct).hidden = false; return; }
        Promise.all(wish.map(function (h) { return fetchSection(ROOT + '/products/' + h, 'fig-card-one').then(function (d) { return $('.card', d); }); })).then(function (cs) {
          cs.filter(Boolean).forEach(function (c) { g.appendChild(c); });
          if (!g.children.length) $('[data-acct-wempty]', acct).hidden = false;
          paintWish(g);
          paintSwatches(g);
        });
        });
      }
    };
    acct.addEventListener('click', function (e) {
      var t = e.target.closest('[data-at]');
      if (t) { showTab(t.dataset.at); history.replaceState(null, '', '#' + t.dataset.at); return; }
      /* Buy again: every piece of the order that is still in stock, in the size and quantity
         bought, into the bag in one go. */
      var ag = e.target.closest('[data-again]');
      if (ag) {
        var items = ag.dataset.again.split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { id: Number(p[0]), quantity: Number(p[1]) || 1 }; });
        if (items.length) addToBag(items);
      }
    });
    if (location.hash && $('[data-at="' + location.hash.slice(1) + '"]', acct)) showTab(location.hash.slice(1));
  }

  /* ── Arabic: the currency ─────────────────────────── */
  /* Shopify formats money once for the whole shop ("22.750 KD"), so on the Arabic site the currency
     is written د.ك here — in the page as served, and in everything added to it afterwards (the bag,
     rails, Load more). Numbers stay as they are. */
  if (DIR < 0) {
    var KD = /\b(KWD|KD)\b/g;
    var fixKD = function (root) {
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var n;
      while ((n = w.nextNode())) if (KD.test(n.nodeValue)) { KD.lastIndex = 0; n.nodeValue = n.nodeValue.replace(KD, 'د.ك'); }
    };
    fixKD(document.body);
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1) fixKD(x); else if (x.nodeType === 3 && KD.test(x.nodeValue)) { KD.lastIndex = 0; x.nodeValue = x.nodeValue.replace(KD, 'د.ك'); } }); }); }).observe(document.body, { childList: true, subtree: true });
  }

  /* A brand page's category tile whose first page had no piece of that category to photograph:
     the first piece of the filtered page gives it one, or the tile goes (sections/fig-main-collection). */
  /* data-tile-want: a pattern the piece's name should match, so a tile isn't photographed with an odd
     piece filed in its category (Paul Kreidi, 20 Oct: "Trouser we have to show only trouser photo").
     The first card that matches, else the first card. */
  /* Also called again when Sale or an offer redraws the tile row in place (24 Oct). */
  function fillTiles(root) { $$('[data-tile-fill]', root).forEach(function (im) {
    if (im.dataset.filling) return;
    im.dataset.filling = '1';
    var want = im.dataset.tileWant ? new RegExp(im.dataset.tileWant, 'i') : null;
    cardsFrom(im.dataset.tileFill).then(function (cs) {
      /* a flat-lay photo first (Dan, 3 Nov: no person on a category tile), else as before */
      var ok = want ? cs.filter(function (x) { return want.test(x.textContent); }) : cs;
      var fc = ok.filter(function (x) { return x.dataset.flat; })[0];
      var c = ok[0] || cs[0];
      var i = c && $('img', c);
      if (fc) { im.src = fc.dataset.flat; im.hidden = false; }
      else if (i) { im.src = i.getAttribute('src'); im.hidden = false; } else { var a = im.closest('.subcat'); if (a) a.remove(); }
    });
  }); }
  fillTiles(document);

  /* ── boot ─────────────────────────────────────────── */
  $$('[data-rail]').forEach(function (r) { if (r.dataset.fill) fillRail(r); else wireRail(r); });
  paintWish(document);
  paintSwatches(document);

  /* ── welcome offer ─────────────────────────────────── */
  /* Never on the first screen a visitor sees (UI review, 19 Oct: it covered the hero on first load):
     on the second page they open, or after 20 seconds on the first, once per session, and never
     while the products in view are still loading. Closed or signed up, it doesn't come back on that
     device. Not on cart or account pages; after the sign-up posts back, it opens again with the code. */
  (function () {
    var w = document.getElementById('welcome');
    if (!w) return;
    var pv = 1;
    try { pv = Number(sessionStorage.getItem('lab-pv') || 0) + 1; sessionStorage.setItem('lab-pv', pv); } catch (e) {}
    var thisSession = function () { try { return sessionStorage.getItem('lab-welcome-s'); } catch (e) { return '1'; } };
    /* a grid or rail on screen that is empty or still drawing its photos */
    var settled = function () {
      return !$$('[data-track], .grid').some(function (g) {
        if (g.closest('[hidden]')) return false;
        var r = g.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return false;
        if (!g.children.length) return true;
        return $$('img', g).some(function (i) { var b = i.getBoundingClientRect(); return b.top < innerHeight && b.bottom > 0 && !i.complete; });
      });
    };
    var KEY = 'lab-welcome';
    var seen = function () { try { return localStorage.getItem(KEY); } catch (e) { return '1'; } };
    var mark = function (v) { try { localStorage.setItem(KEY, v); } catch (e) {} };
    var open = function () { w.hidden = false; var i = w.querySelector('input[type=email]'); if (i) setTimeout(function () { i.focus(); }, 50); };
    var close = function () { w.hidden = true; if (seen() !== 'joined') mark('closed'); };
    w.addEventListener('click', function (e) { if (e.target.closest('[data-wx]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !w.hidden) close(); });
    var f = w.querySelector('form');
    if (f) f.addEventListener('submit', function () { mark('joined'); });
    if (w.querySelector('[data-posted]') || /customer_posted=true/.test(location.search) && /welcome/.test(location.hash)) { mark('joined'); open(); return; }
    if (seen() || /^\/(ar\/)?(cart|account|pages\/my-account|pages\/returns)/.test(location.pathname)) return;
    if (thisSession()) return;
    /* never on top of a drawer, the bag, the search panel or a grid still loading: wait until it's clear */
    var tryOpen = function () {
      if (seen() || thisSession()) return;
      if (document.querySelector('.fd:not([hidden]), .bag:not([hidden]), .drawer:not([hidden]), .spanel:not([hidden]), .zoom') || !settled()) { setTimeout(tryOpen, 2500); return; }
      try { sessionStorage.setItem('lab-welcome-s', '1'); } catch (e) {}
      open();
    };
    setTimeout(tryOpen, pv >= 2 ? 4000 : 20000);
  })();

  /* ── the hover photo ──────────────────────────────── */
  /* Hovering a card shows the piece worn, never a close-up of the fabric (Paul Kreidi, 18 Oct: Tom
     Tailor's second photo is often "the material and color as plain"). Brands order their photos
     differently, so the card looks at its other photos (data-alts, tiny copies) the first time it is
     hovered: a photo whose edges are not the first photo's studio background fills the frame — a
     close-up — and is skipped; of the rest, the one with the most skin tone (a model) wins. With
     nothing suitable, the card keeps its first photo. The choice is remembered for the session. */
  (function () {
    if (!matchMedia('(hover: hover) and (min-width: 1111px)').matches) return;
    var memo = {};
    try { memo = JSON.parse(sessionStorage.getItem('lab-hv') || '{}'); } catch (e) {}
    var save = function () { try { sessionStorage.setItem('lab-hv', JSON.stringify(memo)); } catch (e) {} };
    var small = function (u) { return u.replace(/([?&])width=\d+/, '$1width=60'); };
    var look = function (url) {
      return new Promise(function (res) {
        var im = new Image();
        im.onload = function () {
          try {
            var w = 24, h = 36, c = document.createElement('canvas');
            c.width = w; c.height = h;
            var x = c.getContext('2d');
            x.drawImage(im, 0, 0, w, h);
            var d = x.getImageData(0, 0, w, h).data, er = 0, eg = 0, eb = 0, en = 0, sk = 0;
            for (var i = 0; i < d.length; i += 4) {
              var r = d[i], g = d[i + 1], b = d[i + 2], p = i / 4, px = p % w, py = Math.floor(p / w);
              if (px < 2 || px >= w - 2 || py < 2) { er += r; eg += g; eb += b; en++; }
              var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
              if (r > 95 && g > 40 && b > 20 && r > g && r > b && r - g > 15 && mx - mn > 15 && r < 250 && g < 230) sk++;
            }
            res({ edge: [er / en, eg / en, eb / en], skin: sk / (w * h) });
          } catch (e) { res(null); }
        };
        im.onerror = function () { res(null); };
        im.src = small(url);
      });
    };
    var near = function (a, b) { return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]) < 60; };
    var pick = function (card) {
      var ph = $('a.ph', card), first = ph && $('img', ph);
      if (!ph || !first || ph.dataset.hvDone) return;
      ph.dataset.hvDone = '1';
      var alts = (ph.dataset.alts || '').split(' ').filter(Boolean).slice(0, 4);
      var id = card.dataset.id;
      var apply = function (u) {
        if (!u || ph.dataset.picked) return; /* a colour chosen on the card has set its own hover photo */
        var second = $$('img', ph)[1];
        if (!second) { second = document.createElement('img'); second.alt = ''; ph.appendChild(second); }
        second.removeAttribute('srcset'); second.removeAttribute('sizes'); second.loading = 'eager';
        second.src = u;
        ph.dataset.hv = '1';
      };
      if (id in memo) { apply(alts[memo[id]]); return; }
      if (!alts.length) return;
      Promise.all([look(first.currentSrc || first.src)].concat(alts.map(look))).then(function (r) {
        var ref = r[0], best = -1, bestSkin = -1, firstOk = -1;
        r.slice(1).forEach(function (s, k) {
          if (!s || !ref || !near(s.edge, ref.edge)) return;
          if (firstOk < 0) firstOk = k;
          if (s.skin > bestSkin) { bestSkin = s.skin; best = k; }
        });
        var chosen = bestSkin > 0.04 ? best : firstOk;
        memo[id] = chosen >= 0 ? chosen : -1;
        save();
        apply(alts[memo[id]]);
      });
    };
    document.addEventListener('mouseover', function (e) { var c = e.target.closest && e.target.closest('.card'); if (c) pick(c); });
  })();

  /* A photo Shopify's image server failed to make. About 1 request in 100 comes back 502 the first
     time a size of a photo is asked for (seen 22 Oct on La Vie en Rose: the card stayed grey until
     hover showed the second photo). The same address asked again usually works, so: once more as it
     was (a fresh address, so no cached failure is reused), then once at one plain size, and on a card
     whose first photo still fails, the card's next photo takes its place rather than a grey box. */
  (function () {
    var fresh = function (u, n) { return u ? u.replace(/([?&])retry=\d+&?/, '$1').replace(/[?&]$/, '') + (u.indexOf('?') >= 0 ? '&' : '?') + 'retry=' + n : u; };
    document.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG' || !/\/cdn\/shop\/|cdn\.shopify\.com/.test(img.currentSrc || img.src)) return;
      var n = Number(img.dataset.retry || 0) + 1;
      if (n > 3) return; /* the stand-in failed too: stop, never loop */
      img.dataset.retry = n;
      if (n === 1) {
        setTimeout(function () {
          if (img.srcset) img.srcset = img.srcset.split(',').map(function (s) { var p = s.trim().split(/\s+/); return fresh(p[0], 1) + (p[1] ? ' ' + p[1] : ''); }).join(', ');
          img.src = fresh(img.src, 1);
        }, 700);
      } else if (n === 2) {
        setTimeout(function () {
          img.removeAttribute('srcset'); img.removeAttribute('sizes');
          img.src = fresh(img.src.replace(/([?&])width=\d+/, '$1width=600'), 2);
        }, 1500);
      } else {
        var ph = img.closest('a.ph');
        var next = ph && $$('img', ph).filter(function (x) { return x !== img && x.naturalWidth > 0; })[0];
        var alt = ph && (ph.dataset.alts || '').split(' ').filter(Boolean)[0];
        if (next || alt) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = next ? next.currentSrc || next.src : alt; }
      }
    }, true);
  })();

  /* The WhatsApp button steps aside while the shopper scrolls down and comes back when they scroll
     up or stop near the top, so it no longer sits on carousel arrows (UI review H8). */
  (function () {
    var wa = $('.wa-float');
    if (!wa) return;
    var y = scrollY;
    addEventListener('scroll', function () {
      var ny = scrollY;
      if (Math.abs(ny - y) < 12) return;
      wa.classList.toggle('away', ny > y && ny > 240);
      y = ny;
    }, { passive: true });
  })();

  /* A colour's circle on a card shows that colour's photo (Dan, 28 Oct: "when i hover or click on the swatch … it
     should show the product actual main image"). Hovering a circle previews its photo (data-img) and leaving the
     circles goes back to the card's colour; while the pointer is on the circles the card's own hover photo stays
     back (.sw-on), or it covered the change. A circle with no photo shows the card's colour. */
  function cardPhoto(card, src) {
    var img = $('a.ph img', card);
    if (!img) return;
    if (src) {
      if (!img.dataset.orig) { img.dataset.orig = img.getAttribute('src'); img.dataset.origSet = img.getAttribute('srcset') || ''; }
      if (img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.src = src; }
    } else if (img.dataset.orig && img.getAttribute('src') !== img.dataset.orig) {
      img.src = img.dataset.orig;
      if (img.dataset.origSet) img.setAttribute('srcset', img.dataset.origSet);
    }
  }
  /* Clicking a colour of the card's own product makes it the card's colour: its photo stays, its second photo
     becomes the hover photo (none when it has no second photo, so hovering never shows another colour), and the
     card opens the product on that colour. */
  function pickColour(card, sw) {
    card.dataset.cur = sw.dataset.img || '';
    cardPhoto(card, card.dataset.cur);
    var ph = $('a.ph', card);
    if (!ph) return;
    ph.scrollLeft = 0;
    ph.dataset.picked = '1';
    ph.dataset.hvDone = '1';
    if (sw.dataset.img2) {
      var second = $$('img', ph)[1];
      if (!second) { second = document.createElement('img'); second.alt = ''; ph.appendChild(second); }
      second.removeAttribute('srcset'); second.removeAttribute('sizes'); second.loading = 'eager';
      second.src = sw.dataset.img2;
      ph.dataset.hv = '1';
    } else if (sw.dataset.img) {
      delete ph.dataset.hv;
    }
    if (sw.dataset.url) $$('a.ph, .c-name a', card).forEach(function (a) { a.setAttribute('href', sw.dataset.url); });
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.c-sw [data-swatch]');
    /* a card the pointer left without a mouseout (it went straight into a frame) goes back on the next move */
    $$('.card.sw-on').forEach(function (c) { if (!sw || !c.contains(sw)) { c.classList.remove('sw-on'); cardPhoto(c, c.dataset.cur || ''); } });
    var card = sw && sw.closest('.card');
    if (!card) return;
    card.classList.add('sw-on');
    cardPhoto(card, sw.dataset.img || card.dataset.cur || '');
  });
  document.addEventListener('mouseout', function (e) {
    var row = e.target.closest && e.target.closest('.c-sw');
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    var card = row.closest('.card');
    if (!card) return;
    card.classList.remove('sw-on');
    cardPhoto(card, card.dataset.cur || '');
  });
})();
